export default { options: { label: 'StandingOthers' } }
